import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { featuredTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 border-y border-mist bg-cream" data-id="element-201" data-mp="3sq1whyi8a21r">
      <div className="max-w-7xl mx-auto px-4" data-id="element-202" data-mp="3srmszto3rv29">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-203" data-mp="3nz21iyso5u1w">
          {featuredTestimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-ivory border border-gold/30 p-6 rounded-2xl relative" data-id="element-204" data-mp="5kkqdfp2vgct" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-205" data-mp="aiuljqasygyf">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" aria-hidden="true" data-id="element-206" data-mp="2cd3m1x15b1fr" data-mpi={starIndex} />)}
              </div>
              <p className="text-ink/80 italic mb-6 text-sm leading-relaxed" data-id="element-207" data-mp="cek3t884ixif">“{testimonial.text}”</p>
              <div className="flex items-center gap-3" data-id="element-208" data-mp="gekhurrb96oy">
                <div className="w-10 h-10 rounded-full bg-brand text-cream border border-gold flex items-center justify-center font-bold" data-id="element-209" data-mp="ld5igsah5sdx">
                  {testimonial.initials}
                </div>
                <div data-id="element-210" data-mp="v405vzzgiy0y">
                  <div className="font-bold text-brand text-sm" data-id="element-211" data-mp="v2fay998dd2k">{testimonial.name}</div>
                  <div className="text-xs text-olive" data-id="element-212" data-mp="1018rybnq7m7h">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}